const BLStudio = () => {
  return <div className="text-white p-10">BL Studio Page</div>;
};

export default BLStudio;
